import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "source-info"
}
const _hoisted_2 = {
  key: 1,
  class: "collection-status"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "bot-score"
}

import { Language } from "../../../src/Types";
import { computed } from "vue";
import { UniqueCard } from "@/CardTypes";
import CardComponent from "./Card.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BoosterCard',
  props: {
    card: {},
    language: { default: Language.en },
    selected: { type: Boolean, default: false },
    canbeburned: { type: Boolean, default: false },
    burned: { type: Boolean },
    wildcardneeded: { type: Boolean, default: false },
    hasenoughwildcards: { type: Boolean, default: true },
    botscore: { default: null },
    botpicked: { type: Boolean, default: false },
    scale: { default: 1 },
    renderCommonBackside: { type: Boolean, default: false }
  },
  emits: ["burn", "restore"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function burnCard(e: Event) {
	emit("burn");
	e.stopPropagation();
	e.preventDefault();
}

function restoreCard(e: Event) {
	emit("restore");
	e.stopPropagation();
	e.preventDefault();
}

const displayBotScore = computed(() => {
	if (props.botscore === null) return null;
	if (props.botscore < 0) return null;
	return props.botscore.toFixed(1);
});

const sourceInfo = computed(() => {
	if (!props.card.slot && !props.card.sheet) return null;
	return [props.card.slot, props.card.sheet].filter((s) => typeof s === "string").join(" / ");
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(CardComponent, {
    card: __props.card,
    language: __props.language,
    class: _normalizeClass([{ selected: __props.selected, burned: __props.burned, 'bot-picked': __props.botpicked }, "booster-card"]),
    style: _normalizeStyle(`--booster-card-scale: ${__props.scale}`),
    renderCommonBackside: __props.renderCommonBackside
  }, {
    default: _withCtx(() => [
      (sourceInfo.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(sourceInfo.value), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (__props.wildcardneeded)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!__props.hasenoughwildcards)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: "fa-solid fa-exclamation-triangle",
                  class: "yellow missing-warning"
                }))
              : _createCommentVNode("v-if", true),
            _createElementVNode("img", {
              class: "wildcard-icon",
              src: `img/wc_${__props.card.rarity}.webp`
            }, null, 8 /* PROPS */, _hoisted_3)
          ])), [
            [
              _directive_tooltip,
              
				`Playing this card will cost you a wildcard. ${
					__props.hasenoughwildcards ? '' : 'Not enough wildcards of this type!'
				}`
			,
              void 0,
              { top: true }
            ]
          ])
        : _createCommentVNode("v-if", true),
      (displayBotScore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(displayBotScore.value), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (__props.canbeburned && !__props.selected)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (__props.burned)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "restore-card blue clickable",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (restoreCard($event)))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-undo-alt",
                    size: "2x"
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "burn-card red clickable",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (burnCard($event)))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-ban",
                    size: "2x"
                  })
                ]))
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["card", "language", "class", "style", "renderCommonBackside"]))
}
}

})